import { changeResizeColumn, currencyMap, lang, country_locale } from "@/utils"
import request from '@/service/request'
import { App } from "vue"

/**
 * @description: 全局注册方法
 * @param {App} app
 * @global $lang, $req, $changeResizeColumn, $currencyMap, $country_locale
 * @return {*}
 */
export default function registerGlobalProperties(app: App): void {
  app.config.globalProperties.$lang = lang
  app.config.globalProperties.$req = request
  app.config.globalProperties.$changeResizeColumn = changeResizeColumn
  app.config.globalProperties.$currencyMap = currencyMap
  app.config.globalProperties.$country_locale = country_locale
}